module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c17"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _vm._v("Popping the Clutch")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("T")]), _vm._v("wo lovebirds from Naples, Italy, were fooling around at a local lovers’ lane in their subcompact car when the car was accidentally hit from behind. The couple claimed they “lost control” during the collision and are suing to recover the expenses of their unplanned pregnancy. I guess the airbags weren’t the only thing that deployed."), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L02_r1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('em', [_vm._v("“I was trying to drive her back to shore.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Excuse used by a Pittsburgh man who was apparently throwing rocks at his wife, struggling not to drown in the Kanawha River.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ad11a0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740792069_epub_c17_r1.vue
// module id = 123
// module chunks = 0